import React, { createContext, useReducer } from "react";

export const LoginContext = createContext();

const initialState = {
  isLogin: false,
  user: null,
  loading: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "USER_LOADED":
      return {
        ...state,
        isLogin: true,
        loading: false,
        user: action.payload,
      };
    case "AUTH_ERROR":
    case "LOGIN_FAIL":
      return {
        ...state,
        isLogin: false,
        loading: false,
        user: null,
      };
    case "LOGIN_SUCCESS":
      sessionStorage.setItem("token", action.payload.token);
      return {
        ...state,
        isLogin: true,
        loading: false,
      };
    case "UPDATE_USER":
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          img: action.payload,
        },
      };
    case "LOGOUT":
      sessionStorage.removeItem("token");
      return {
        ...state,
        isLogin: false,
        user: null,
      };
    default:
      throw new Error();
  }
};

export const LoginContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <LoginContext.Provider value={[state, dispatch]}>
      {props.children}
    </LoginContext.Provider>
  );
};
